import { render } from "./StageMaterial.vue?vue&type=template&id=207c678c&scoped=true"
import script from "./StageMaterial.vue?vue&type=script&lang=js"
export * from "./StageMaterial.vue?vue&type=script&lang=js"

import "./StageMaterial.vue?vue&type=style&index=0&id=207c678c&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207c678c"]])

export default __exports__